import { InfoWindow } from "@vis.gl/react-google-maps";
import Avatar from "react-avatar";
import { Link } from "react-router-dom";

export const InfoWindowPopup = ({
  infoWindowShown,
  selectedMarker,
  handleCloseInfoWindow,
  type = "",
}) => {
  console.log("selectedMarker", selectedMarker);
  console.log("type", type);
  
  // Early return if no valid data
  if (!infoWindowShown || !selectedMarker?.selectedMarker || !selectedMarker?.entityData) {
    return null;
  }

  // Ensure entityData is an array
  const entityData = Array.isArray(selectedMarker.entityData) 
    ? selectedMarker.entityData 
    : [selectedMarker.entityData];
  
  const firstEntity = entityData[0];
  
  if (!firstEntity) {
    return null;
  }
  const outletName = firstEntity?.restaurant_name || firstEntity?.outlet_name;
  const outletId = firstEntity?._id || firstEntity?.id;

  let entityType;

  if (type === "hubspots") {
    entityType = "hubspots";
  } else if (firstEntity?.customer_name) {
    entityType = "orders";
  } else if (firstEntity?.business_coordinatesX) {
    entityType = "outlets";
  } else if (firstEntity?.shift_schedule) {
    entityType = "drivers";
  } else {
    entityType = "unknown";
  }

  return (
    <InfoWindow
      anchor={selectedMarker.selectedMarker}
      className="custom-info-window"
      onCloseClick={handleCloseInfoWindow}
    >
      {entityType === "orders" && (
        <>
          <div className="px-5 pb-3 rounded-md w-full h-full flex items-center 2xl:gap-4 xl:gap-3 lg:gap-3 overflow-auto">
            <Avatar
              name={firstEntity?.customer_name}
              size="45"
              round={true}
              maxInitials={2}
              textSizeRatio={3}
              style={{ letterSpacing: "1px" }}
            />
            <div className="flex flex-col 2xl:gap-1.5 xl:gap-1.5 lg:gap-1.5">
              <h2 className="2xl:text-[18px] xl:text-[13px] lg:text-[12px] font-semibold tracking-wide break-words">
                {firstEntity?.customer_name}
              </h2>
            </div>
          </div>

          <hr className="border border-[#F7631D] rounded-full w-[90%] m-auto mt-1 mb-3" />

          <div className="w-[88%] m-auto pb-3">
            {[
              {
                label: "Order ID:",
                value: firstEntity?.orderId,
              },
              {
                label: "Contact no.:",
                value: firstEntity?.customer_phone || "N/A",
              },
            ].map((item, idx) => (
              <div key={idx} className="flex items-start gap-2 w-full py-2">
                <p className="2xl:text-[12px] xl:text-[10px] lg:text-[10px] font-semibold tracking-wide w-1/2 break-all">
                  {item.label}
                </p>
                <p className="2xl:text-[12px] xl:text-[10px] lg:text-[10px] font-semibold tracking-wide w-1/2 break-all">
                  {item.value}
                </p>
              </div>
            ))}
          </div>

          <div className="w-[88%] m-auto pt-3 pb-6">
            <Link
              to={`/orders/${firstEntity?._id}`}
              className="bg-[#F7631D] text-white px-4 py-2 rounded-lg font-medium tracking-wider"
            >
              View More
            </Link>
          </div>
        </>
      )}

      {entityType === "drivers" && (
        <>
          <div className="px-5 pb-3 rounded-md w-full h-full flex items-center 2xl:gap-4 xl:gap-3 lg:gap-3 overflow-auto">
            {firstEntity?.driver_image ? (
              firstEntity?.driver_image?.includes("img.freepik.com") ? (
                <Avatar
                  name={firstEntity?.name}
                  size="40"
                  round={true}
                  maxInitials={2}
                  textSizeRatio={2.5}
                  style={{ letterSpacing: "1px" }}
                />
              ) : (
                <img
                  src={firstEntity?.driver_image}
                  alt=""
                  className="h-[40px] rounded-full"
                />
              )
            ) : (
              <Avatar
                name={firstEntity?.name}
                size="40"
                round={true}
                maxInitials={2}
                textSizeRatio={2.5}
                style={{ letterSpacing: "1px" }}
              />
            )}

            <div className="flex flex-col 2xl:gap-1.5 xl:gap-1.5 lg:gap-1.5">
              <h2 className="2xl:text-[16px] xl:text-[13px] lg:text-[12px] font-semibold tracking-wide break-words">
                {firstEntity?.name}
              </h2>
            </div>
          </div>

          <hr className="border border-[#F7631D] rounded-full w-[90%] m-auto mt-1 mb-3" />

          <div className="w-[88%] m-auto pb-3">
            {[
              {
                label: "Driver ID:",
                value: firstEntity?.driverID || "N/A",
              },
              {
                label: "Contact no.:",
                value: firstEntity?.phone || "N/A",
              },
            ].map((item, idx) => (
              <div key={idx} className="flex items-start gap-2 w-full py-2">
                <p className="2xl:text-[12px] xl:text-[10px] lg:text-[10px] font-semibold tracking-wide w-1/2 break-all">
                  {item.label}
                </p>
                <p className="2xl:text-[12px] xl:text-[10px] lg:text-[10px] font-semibold tracking-wide w-1/2 break-all">
                  {item.value}
                </p>
              </div>
            ))}
          </div>

          <div className="w-[88%] m-auto pt-3 pb-5">
            <Link
              to={`/drivers/${firstEntity?._id}`}
              className="bg-[#F7631D] text-white px-4 py-2 rounded-lg font-medium tracking-wider"
            >
              View More
            </Link>
          </div>
        </>
      )}

      {entityType === "outlets" && (
        <div className="w-[230px] rounded-xl bg-white px-4 py-4 text-[#413F3F]">
          <div className="flex items-center gap-3">
            <div className="rounded-full ring-2 ring-[#F7631D]/15">
              <Avatar
                name={outletName}
                size="44"
                round={true}
                maxInitials={2}
                textSizeRatio={2.5}
                style={{ letterSpacing: "1px" }}
              />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-[11px] font-semibold uppercase tracking-wide text-[#F7631D]">
                Outlet
              </p>
              <h2 className="mt-0.5 text-[15px] font-semibold leading-snug capitalize break-words">
                {outletName || "Outlet"}
              </h2>
            </div>
          </div>

          <div className="mt-4">
            <Link
              to={`/outlets/${outletId}`}
              className="flex w-full items-center justify-center rounded-lg bg-[#F7631D] px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#d55419]"
            >
              See more
            </Link>
          </div>
        </div>
      )}

      {type === "hubspots" && (
        <>
          <div className="px-5 pb-3 rounded-md w-full h-full flex items-center 2xl:gap-4 xl:gap-3 lg:gap-3 overflow-auto">
            <Avatar
              name={"Hubspot"}
              size="40"
              round={true}
              maxInitials={2}
              textSizeRatio={2.5}
              style={{ letterSpacing: "1px" }}
            />
            <div className="flex flex-col 2xl:gap-1.5 xl:gap-1.5 lg:gap-1.5">
              <h2 className="2xl:text-[16px] xl:text-[13px] lg:text-[12px] font-semibold tracking-wide break-words">
                Hubspots - {entityData?.length || 0}
              </h2>
            </div>
          </div>

          <hr className="border border-[#F7631D] rounded-full w-[90%] m-auto mt-1" />
          <ul className="overflow-auto mt-2 bg-white rounded-lg shadow-lg z-30">
            {entityData &&
              entityData.map((outlet, index) => (
                <li
                  className="px-5 py-3 w-full h-full flex flex-col justify-center items-center"
                  key={index}
                >
                  <Link
                    to={`/outlets/${outlet?._id || outlet?.id}`}
                    className="flex justify-between items-center w-full 2xl:gap-2 xl:gap-3 lg:gap-3"
                  >
                    <div className="flex items-center 2xl:gap-4 xl:gap-3 lg:gap-3">
                      <Avatar
                        name={outlet?.restaurant_name || outlet?.outlet_name}
                        size="40"
                        round={true}
                        maxInitials={2}
                        textSizeRatio={2.5}
                        style={{ letterSpacing: "1px" }}
                      />
                      <p className="py-2 cursor-pointer text-sm font-medium tracking-wide capitalize">
                        {outlet?.restaurant_name || outlet?.outlet_name}
                      </p>
                    </div>
                    <img
                      src="/assets/right-arrow.png"
                      alt="Arrow"
                      className="h-3"
                    />
                  </Link>

                  {index < entityData.length - 1 && (
                    <hr className="border border-[#00000040] rounded-full w-[100%] m-auto mt-2" />
                  )}
                </li>
              ))}
          </ul>
        </>
      )}
    </InfoWindow>
  );
};
